<template>
    <div>
        <headroom :z-index="1000">
            <header class="main-header">
                <div class="container main-header__inner">
                    <router-link 
                        :to="{ name: 'home' }" 
                        class="main-header__logo">
                        <img src="/img/logo.png/300x0_ratio/logo.png" alt="Logo">
                    </router-link>
                    <div class="main-header__nav">
                        <nav class="main-header__navigation">
                            <menu-component 
                                :pages="$store.state.navigation.items" 
                                list-class="main-header__list" 
                                submenu-class="main-header__sub" 
                                item-class="main-header__item" 
                                link-class="main-header__link">
                            </menu-component>
                        </nav>
                    
                        <div v-if="$store.state.languages.length > 1" class="main-header__lang">
                            <language-switch-component></language-switch-component>
                        </div>
                    </div>
                </div>
            </header>
        </headroom>

        <div class="mobile-nav__action">
            <div class="d-flex align-items-center pl-1">
                <a class="mobile-nav__link mr-2" href="tel:805-688-2628" data-ga-track data-ga-category="Phone" data-ga-action="call" data-ga-label="805-688-2628">
                    <svg width="25px" height="25px" aria-hidden="true" data-prefix="fal" data-icon="phone" class="svg-inline--fa fa-phone fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M487.8 24.1L387 .8c-14.7-3.4-29.8 4.2-35.8 18.1l-46.5 108.5c-5.5 12.7-1.8 27.7 8.9 36.5l53.9 44.1c-34 69.2-90.3 125.6-159.6 159.6l-44.1-53.9c-8.8-10.7-23.8-14.4-36.5-8.9L18.9 351.3C5 357.3-2.6 372.3.8 387L24 487.7C27.3 502 39.9 512 54.5 512 306.7 512 512 307.8 512 54.5c0-14.6-10-27.2-24.2-30.4zM55.1 480l-23-99.6 107.4-46 59.5 72.8c103.6-48.6 159.7-104.9 208.1-208.1l-72.8-59.5 46-107.4 99.6 23C479.7 289.7 289.6 479.7 55.1 480z"></path></svg>
                </a>
                <a class="mobile-nav__link mr-2" href="mailto:infocustomarchstone@gmail.com" data-ga-track data-ga-category="E-Mail" data-ga-action="click" data-ga-label="infocustomarchstone@gmail.com">
                    <svg width="25px" height="25px" aria-hidden="true" data-prefix="fal" data-icon="envelope" class="svg-inline--fa fa-envelope fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z"></path></svg>
                </a>
                <a class="mobile-nav__link mr-2" href="https://goo.gl/maps/zG9dMYMihwbWzad4A" target="_blank" data-ga-track data-ga-category="Map" data-ga-action="click">
                    <svg width="25px" height="25px" aria-hidden="true" data-prefix="fal" data-icon="map-marker-alt" class="svg-inline--fa fa-map-marker-alt fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M192 96c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm0-256C85.961 0 0 85.961 0 192c0 77.413 26.97 99.031 172.268 309.67 9.534 13.772 29.929 13.774 39.465 0C357.03 291.031 384 269.413 384 192 384 85.961 298.039 0 192 0zm0 473.931C52.705 272.488 32 256.494 32 192c0-42.738 16.643-82.917 46.863-113.137S149.262 32 192 32s82.917 16.643 113.137 46.863S352 149.262 352 192c0 64.49-20.692 80.47-160 281.931z"></path></svg>
                </a>
            </div>
            <div class="mobile-nav__hamburger">
                <button 
                    class="hamburger hamburger--spin" 
                    :class="{ 'is-active': $store.state.navigation.isOpen }" 
                    @click="$store.dispatch('navigation/toggle')"
                    type="button">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
            </div>
        </div>
        <transition name="mobile-nav">
            <div v-show="$store.state.navigation.isOpen" class="mobile-nav">
                <nav class="main-header__navigation">
                    <router-link 
                        :to="{ name: 'home' }" 
                        class="main-header__logo mb-3">
                        <img src="/img/logo.png/300x0_ratio/logo.png" alt="Logo">
                    </router-link>
                    <menu-component 
                        :pages="$store.state.navigation.items" 
                        list-class="main-header__list" 
                        submenu-class="main-header__sub" 
                        item-class="main-header__item" 
                        link-class="main-header__link">
                    </menu-component>
                </nav>
            </div>
        </transition>
    </div>
</template>
<script>
import Menu from '#app#/components/package/RF/CMS/Menu.vue';
import LanguageSwitch from '#app#/components/common/LanguageSwitch.vue';
import MemberFrontNav from '#app#/components/package/RF/Member/FrontNav.vue';
import { headroom } from 'vue-headroom';

export default {
    components: {
        headroom,
        'menu-component': Menu,
        'language-switch-component': LanguageSwitch,
        'member-frontnav-component': MemberFrontNav
    },

    watch: {
        $route() {
            this.$store.dispatch('navigation/close');
        }
    },
}
</script>



// WEBPACK FOOTER //
// js/components/common/Navigation.vue